import type React from 'react';

import { Link } from '@change-corgi/design-system-legacy/components/actions';
import { Text } from '@change-corgi/design-system-legacy/typography';

type Props = {
	id: string;
	displayName: string;
	title: string | null;
	dmSlug: string | null;
	publiclyVisible: boolean;
	trackProfileLinkClick: (id: string) => void;
};

export const NameAndTitle: React.FC<Props> = ({
	id,
	displayName,
	title,
	dmSlug,
	publiclyVisible,
	trackProfileLinkClick,
}) => {
	return (
		<div>
			{publiclyVisible ? (
				<Link
					data-testid="dm-profile-link"
					data-qa="dm-profile-link"
					sx={{ fontWeight: 'bold' }}
					to={`/decision-makers/${dmSlug || id}?source_location=starter_dashboard`}
					onClick={() => trackProfileLinkClick(id)}
				>
					<Text size="large" fontWeight="semibold" ellipsis>
						{displayName}
					</Text>
				</Link>
			) : (
				<Text size="large" fontWeight="semibold" ellipsis>
					{displayName}
				</Text>
			)}
			{title && (
				<Text data-testid="dm-title" size="small" ellipsis>
					{title}
				</Text>
			)}
		</div>
	);
};
